module.exports = __webpack_public_path__ + "static/media/40_B.5f6d072c.png";